import { Component, inject } from '@angular/core';
import { Divider } from 'primeng/divider';
import { Avatar } from 'primeng/avatar';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { AgentPerformanceData } from '../../models/agent-performance';
import { AgentPerformanceService } from '../../services/agent-performance.service';
import { ToastService } from '../../services/toast.service';
import { Tag } from 'primeng/tag';
import { WithdrawalHealthRiskEnum } from '../../models/withdrawal-health-check';
import { DateTimePipe } from '../../pipes/date-time.pipe';
import { Skeleton } from 'primeng/skeleton';
import { CurrencyPipe } from '../../pipes/currency.pipe';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-agent-performance-dialog',
  imports: [Divider, Avatar, Tag, DateTimePipe, Skeleton, CurrencyPipe, DecimalPipe],
  templateUrl: './agent-performance-dialog.html',
  styleUrl: './agent-performance-dialog.scss',
})
export class AgentPerformanceDialog {
  private config = inject(DynamicDialogConfig);
  private agentPerformanceService = inject(AgentPerformanceService);
  private toastService = inject(ToastService);

  loading = false;
  data: AgentPerformanceData | undefined;

  protected readonly RiskEnum = WithdrawalHealthRiskEnum;

  constructor() {
    this.getAgentPerformanceData();
  }

  getAgentPerformanceData() {
    this.loading = true;
    this.agentPerformanceService
      .getAgentPerformanceData(this.config.data.agentId)
      .then((data) => {
        if (data) {
          this.data = data;
          this.loading = false;
        }
      })
      .catch((error) => {
        this.toastService.showError('Error fetching data: ' + error.message);
        this.loading = false;
      });
  }
}
